import { AgregationService } from '@ispm-client/modules/aggregator/services';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class MenuItemService {
  constructor (
    private aggregatorService: AgregationService,
  ) { }

  getShowCountValue(dataBinding: Array<any>): Observable<any>  {
    if (Object.keys(dataBinding[0]).length > 0) {
      return this.aggregatorService.registerQuery(dataBinding).
      map(response => response[0]['unApprovedEvent']['count']);
    } else {
      return Observable.of(0);
    }
  }
}


